import { Box } from '@chakra-ui/react';

export const Toggle = ({ isChecked, onChange }) => {
  return (
    <Box
      as="button"
      onClick={() => onChange(!isChecked)}
      w="44px"
      h="24px"
      bg="blue.500"
      borderRadius="full"
      p="2px"
      display="flex"
      alignItems="center"
      transition="all 0.2s"
    >
      <Box
        w="20px"
        h="20px"
        bg="white"
        borderRadius="full"
        transform={isChecked ? 'translateX(20px)' : 'translateX(0px)'}
        transition="all 0.2s ease-in-out"
      />
    </Box>
  );
};
